import React from 'react'
import { BsLinkedin } from 'react-icons/bs'
import { FaFacebook, FaGithub } from 'react-icons/fa'
import './footer.css'

const Footer = () => {
  return (
    <footer>
      <a href='#home' className='footer__logo'>
        Zineddine Benkhaled
      </a>
      <ul className='permalinks'>
        <li>
          <a href='#home'>Home</a>
        </li>
        <li>
          <a href='#about'>About</a>
        </li>
        <li>
          <a href='#experience'>Skills</a>
        </li>
        <li>
          <a href='#portfolio'>Portfolio</a>
        </li>
        <li>
          <a href='#testimonials'>Testimonials</a>
        </li>
        <li>
          <a href='#contact'>Contact</a>
        </li>
      </ul>

      <div className='footer__socials'>
        <a
          href='https://www.linkedin.com/in/zineddine-benkhaled-b9b1a8195/'
          target='_blank'
          rel='noreferrer'
        >
          <BsLinkedin />
        </a>
        <a
          href='https://github.com/ZineddineBk09'
          target='_blank'
          rel='noreferrer'
        >
          <FaGithub />
        </a>
        <a
          href='https://www.facebook.com/zino.benkhaled'
          target='_blank'
          rel='noreferrer'
        >
          <FaFacebook />
        </a>
      </div>
      <div className='footer__copyright'>
        <small>&copy; 2022. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
